import { useLayoutEffect, useState } from 'react';

import { clamp, isBetween } from '@/lib/helper';

export default function useScrollSpy(
  ids: string[],
  offset: number,
  activeSection?: string,
) {
  const [activeId, setActiveId] = useState(activeSection || '');
  const firstSection = activeSection || '';
  const debounce = (fn: () => void, ms = 300) => {
    let timeoutId: ReturnType<typeof setTimeout>;

    return function (this: unknown, ...args: []) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(this, args), ms);
    };
  };

  useLayoutEffect(() => {
    const listener = () => {
      const scroll = window.scrollY || window.pageYOffset;

      const position = ids
        .map((id) => {
          const element = document.getElementById(id);

          if (!element) return { id, top: -1, bottom: -1 };

          const rect = element.getBoundingClientRect();
          const top = clamp(rect.top + scroll - offset);
          const bottom = clamp(rect.bottom + scroll - offset);

          return { id, top, bottom };
        })
        .find(({ top, bottom }) => isBetween(scroll, top, bottom));

      setActiveId(position?.id || firstSection);
    };

    const debouncedListener = debounce(listener, 50);

    listener();

    window.addEventListener('resize', debouncedListener);
    window.addEventListener('scroll', debouncedListener);

    return () => {
      window.removeEventListener('resize', debouncedListener);
      window.removeEventListener('scroll', debouncedListener);
    };
  }, [ids, offset, firstSection]);

  return activeId;
}
